
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AuthHeader from "@/components/layout-component/auth-header.vue";
import SideLayout from "@/components/layout-component/side-layout.vue";
import { Component, Vue } from "vue-property-decorator";
import AiLogin from "@/content/aiLogin.vue";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {
    SideLayout,
    AuthHeader,
    AiLogin
  }
})
export default class App extends Vue {
  show = true; //匿名页面不展示
  showGuide = false; //展示新手引导
  userInfoReady = false; //header里用户信息加载完毕

  get includePages() {
    return vuexStore.keepAlivePages;
  }

  // moka不展示侧边栏和头部
  get showLayout() {
    // return vuexStore.company.channelCode !== "MOKA_V2";
    return true;
  }

  created() {
    document.title = "海纳AI面试";
    this.showGuide = localStorage.getItem("showNewTip") !== "1";
  }
  mounted() {
    // 阅卷页面头部仅供展示
    // this.show =
    //   this.$route.name === "paper-mark" ||
    //   this.$route.name === "candidate-info" ||
    //   this.$route.name === "paper-mark-mobile" ||
    //   this.$route.name === "candidates-info"
    //     ? false
    //     : true;
  }
  closeCompany() {
    vuexStore.updateShowCompany(false);
  }
}
